<template>
  <div class="text-right">
    <b-button
      v-if="isValidStatus()"
      v-b-toggle.sidebar-accept-or-reject-quote
      class="mr-2"
      variant="primary"
    >
      {{ $t('Belgilash') }}
    </b-button>
    <b-sidebar
      id="sidebar-accept-or-reject-quote"
      sidebar-class="sidebar-lg"
      bg-variant="white"
      shadow
      backdrop
      no-header
      right
    >
      <template #default="{ hide }">
        <!-- Header -->
        <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
          <h5 class="mb-0">
            {{ $t('Reject or accept') }}
          </h5>

        </div>

        <!-- Body -->
        <b-form
          class="p-2"
          @submit.prevent
        >
          <b-form-textarea
            id="textarea"
            v-model="rejected_info"
            :placeholder="$t('Comment')"
            rows="3"
            max-rows="6"
          />
          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              :variant="'success'"
              class="mr-2"
              type="submit"
              @click="rejectOrAccept(true,hide)"
            >
              {{ $t('Accept') }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              :variant="'danger'"
              class="mr-2"
              type="submit"
              @click="rejectOrAccept(false,hide)"
            >
              {{ $t('Reject') }}
            </b-button>
          </div>
        </b-form>
      </template>
    </b-sidebar>
  </div>

</template>

<script>
import {
  BButton, VBToggle, BSidebar, BForm, BFormTextarea,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import router from '@/router'
import store from '@/store'

export default {
  name: 'AcceptOrRejectAskedQuote',
  components: {
    BButton,
    BSidebar,
    BForm,
    BFormTextarea,
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  data() {
    return {
      rejected_info: '',
    }
  },
  computed: {
    getStatus() {
      return this.$store.state[this.MODULE_NAME].quoteDistribution.status
    },
  },
  methods: {
    isValidStatus() {
      const {
        quoteDistributionRejected,
        quoteDistributionAccepted,
      } = store.state.staticModule
      if ([quoteDistributionAccepted, quoteDistributionRejected].includes(this.getStatus)) {
        return false
      }
      return true
    },
    rejectOrAccept(isAcceptOrReject, hide) {
      const {
        quoteDistributionRejected,
        quoteDistributionAccepted,
      } = store.state.staticModule
      let acceptedOrRejected = false
      if (isAcceptOrReject) {
        acceptedOrRejected = quoteDistributionAccepted
      } else {
        acceptedOrRejected = quoteDistributionRejected
      }
      this.$removeSwal(this, {
        body: {
          rejected_info: this.rejected_info,
          status: acceptedOrRejected,
        },
        quoteDistributionId: router.currentRoute.params.id,
      }, `${this.MODULE_NAME}/changeQuoteStatus`, () => {
        hide()
        this.$store.dispatch(`${this.MODULE_NAME}/get`, this.$route.params.id)
        this.$emit('refetchTables')
      }, {
        text: '',
        confirmButtonText: 'Yes, accept it!',
        successTitle: 'Accepted!',
        successText: 'Applied successfully',
        errorText: 'There is error for some reason!',
      })
    },
  },
  setup() {
    const MODULE_NAME = 'quoteDistribution'
    return {
      MODULE_NAME,
    }
  },
}
</script>

<style scoped>

</style>
